<template>
  <div class="qr_card_popup" v-if="show_qr_card_pp">
    <div class="bg" @click="hideCardQr"></div>
    <div class="qr-pp-close" @click="hideCardQr"></div>
    <p class="qr-pp-heading">Персональный QR код</p>
    <div class="qr-pp-wp">
      <qrcode :value="getUserCardID" :options="{size: 400}"></qrcode>
    </div>
    <p class="qr-pp-info">Показывайте код на кассе при покупке товаров, чтбы начислять баллы за покупки</p>
  </div>
</template>
<script>
  import Store from '../../store'
  export default {
    computed: {
      show_qr_card_pp: function () {
        return Store.state.show_qr_card_pp
      },
      getUserCardID: function () {
        return Store.state.qrCodeCardNumber
      }
    },
    methods: {
      hideCardQr: function () {
        Store.commit('hideCardQr')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// card-numer-qr-code.vue?3d9c3e45